import React from "react"
import styled, { css } from "styled-components"

function createCSS() {
  let styles = ""

  for (let i = 0; i < 31; i += 1) {
    styles += `
      .container${i}{
        transform: rotate(calc(${i}*12deg));
        .ball{
          animation-delay:calc(-${i}*.3s);
        };
      }
    `
  }
  return css`
    ${styles}
  `
}

export default function LaserBg() {
  return (
    <Wrapper>
      <div className="middle">
        <div className="container1 con">
          <div className="ball"></div>
        </div>
        <div className="container2 con">
          <div className="ball"></div>
        </div>
        <div className="container3 con">
          <div className="ball"></div>
        </div>
        <div className="container4 con">
          <div className="ball"></div>
        </div>
        <div className="container5 con">
          <div className="ball"></div>
        </div>
        <div className="container6 con">
          <div className="ball"></div>
        </div>
        <div className="container7 con">
          <div className="ball"></div>
        </div>
        <div className="container8 con">
          <div className="ball"></div>
        </div>
        <div className="container9 con">
          <div className="ball"></div>
        </div>
        <div className="container10 con">
          <div className="ball"></div>
        </div>
        <div className="container11 con">
          <div className="ball"></div>
        </div>
        <div className="container12 con">
          <div className="ball"></div>
        </div>
        <div className="container13 con">
          <div className="ball"></div>
        </div>
        <div className="container14 con">
          <div className="ball"></div>
        </div>
        <div className="container15 con">
          <div className="ball"></div>
        </div>
        <div className="container16 con">
          <div className="ball"></div>
        </div>
        <div className="container17 con">
          <div className="ball"></div>
        </div>
        <div className="container18 con">
          <div className="ball"></div>
        </div>
        <div className="container19 con">
          <div className="ball"></div>
        </div>
        <div className="container20 con">
          <div className="ball"></div>
        </div>
        <div className="container21 con">
          <div className="ball"></div>
        </div>
        <div className="container22 con">
          <div className="ball"></div>
        </div>
        <div className="container23 con">
          <div className="ball"></div>
        </div>
        <div className="container24 con">
          <div className="ball"></div>
        </div>
        <div className="container25 con">
          <div className="ball"></div>
        </div>
        <div className="container26 con">
          <div className="ball"></div>
        </div>
        <div className="container27 con">
          <div className="ball"></div>
        </div>
        <div className="container28 con">
          <div className="ball"></div>
        </div>
        <div className="container29 con">
          <div className="ball"></div>
        </div>
        <div className="container30 con">
          <div className="ball"></div>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  z-index: -1;
  position: absolute;
  width: 100%;
  height: 130vh;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -55%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  .con {
    position: absolute;
    transform: translate(-100%, -100%);
    transform: rotate(45deg);
    top: 50%;
    left: 50%;
  }
  .middle {
    position: relative;
  }
  .ball {
    opacity: 0;
    width: 1px;
    height: 1px;
    background-color: #fff;
    border-radius: 50%;
    position: absolute;
    animation: ballAni 3s infinite;
  }

  @keyframes ballAni {
    0% {
      transform: translateX(0);
      background-color: #ffffff1d;
      opacity: 0;
    }
    80% {
      opacity: 0.8;
    }
    100% {
      transform: translateX(50vh);
      background-color: white;
      width: 5px;
      height: 5px;
      opacity: 0;
    }
  }
  ${createCSS()};
`
